<div class="reward-center card">
  <div class="reward-card-body card-body">
    <h2 class="reward-title card-title mb-3">
      <span>
        <img
          *ngIf="isMobile"
          (click)="mobileBack()"
          [src]="environment1 + 'assets/images/arrow-left.png'"
          class="img-fluid me-2"
          loading="lazy"
          style="height: 24px"
        />
        Reward Center</span
      >
      <p *ngIf="isMobile" class="balance-text m-0">Balance: ₹ {{ balance }}</p>
    </h2>
    <div class="d-flex justify-content-end searchin ">
      <input
        type="search"
        class="form-control form-control-sm searchinput"
        placeholder="Search Coupon"
        [(ngModel)]="searchData"
        (keydown.enter)="searchAll()"
        (input)="onSearchInput()"
        id="globalSmartSearch" 
      />

      <button  class="btn btn-primary  btn-grad-primary btn-brand btndata" (click)="searchAll()"  [disabled]="!searchData?.trim()">Search</button>
    </div>
    <div
      class="reward-header d-flex justify-content-between align-items-center mb-3"
    >
    <span class="text-muted"
    >{{ totalRewardCard?.redemption_count ? totalRewardCard?.redemption_count : '0' }} cards</span
  >
      
      <!-- <img class="sort-image" [src]="environment1 + 'assets/images/sort.webp'"  alt="sort-image"> -->
    </div>

    <!-- Add row for grid layout -->
    <div class="row reward-grid">
      <!-- Loop through rewards and make each card responsive -->
      <div
        *ngFor="
          let reward of loyalityRewards
            | paginate
              : {
                  itemsPerPage: itemsPerPage,
                  currentPage: currentPage,
                  totalItems: totalItemsOffers,
                  id: 'booking'
                }
        "
        class="col-12 mb-4"
      >
        <div
          class="reward-card-container card h-100 position-relative"
          (click)="navigateToReward(reward)"
        >
          <div
            class="reward-card-body-inner card-body d-flex  align-items-center"
          >
            <div class="reward-image-container flex-shrink-0">
              <div class="reward-image-wrapper">
                <!-- <img [src]="environment1 + 'assets/images/' + reward?.image + '.webp'" alt="{{ reward?.image }}" class="reward-image"> -->

                <img
                  *ngIf="reward?.images?.[3]?.image_url; else fallbackImage"
                  [src]="reward?.images?.[3]?.image_url"
                  alt="Reward Image"
                  class="reward-image"
                />
                <ng-template #fallbackImage>
                  <img
                  [src]='environment1 + "assets/images/amazon-giftcard.png"'
                    alt="Fallback Image"
                    class="reward-image"
                  />
                </ng-template>
              </div>
            </div>
            <div class="reward-details ms-3">
              <h6 class="reward-title mb-0">{{ reward?.product }}</h6>
              <p class="reward-category mb-0">{{ reward?.category }}</p>
              <small class="reward-discount text-primary">{{
                reward.discount
              }}</small>
            </div>
          </div>

          <div class="text-end" (click)="TnCredirect()">
            <small class="text-mutede">T&C Applied</small>
          </div>
        </div>
      </div>
    </div>
    <div class="row reward-grid" *ngIf="loyalityRewards?.length === 0">
      No data found
    </div>
    <div class="col-xs-12 paging-custom" *ngIf="loyalityRewards?.length > 0">
      <pagination-controls
        class="col-xs-12"
        *ngIf="totalItemsOffers > itemsPerPage"
        (pageChange)="pageChangeLoyalityReward($event)"
        previousLabel=" "
        nextLabel=" "
        id="booking"
        [maxSize]="maximumSize"
      ></pagination-controls>
    </div>
  </div>
</div>
